var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 12.1673V6.99994C14 6.72394 13.776 6.49994 13.5 6.49994C13.224 6.49994 13 6.72394 13 6.99994V12.1673C13 12.6266 12.626 13.0006 12.1667 13.0006H3.83267C3.374 13.0006 3 12.6266 3 12.1673V3.83261C3 3.37327 3.374 2.99994 3.83267 2.99994H9.03333C9.30933 2.99994 9.53333 2.77594 9.53333 2.49994C9.53333 2.22394 9.30933 1.99994 9.03333 1.99994H3.83267C2.822 1.99994 2 2.82194 2 3.83261V12.1673C2 13.1786 2.822 13.9999 3.83267 13.9999H12.1667C13.178 13.9999 14 13.1786 14 12.1673ZM5.64667 7.90127L10.7753 2.77594C11.4487 2.10127 12.5487 2.09861 13.2273 2.76794C13.56 3.09594 13.744 3.53394 13.7453 4.00127C13.7467 4.46861 13.5653 4.90727 13.234 5.23727L8.104 10.3526C8.01067 10.4459 7.88333 10.4986 7.75133 10.4986H6C5.724 10.4986 5.5 10.2746 5.5 9.99861V8.25394C5.5 8.12194 5.55267 7.99461 5.64667 7.90127ZM11.354 3.61127L11.4827 3.48261C11.7693 3.19594 12.2367 3.19461 12.5253 3.47994C12.6667 3.61927 12.7447 3.80527 12.7453 4.00394C12.746 4.20327 12.6687 4.38994 12.528 4.52994L12.4087 4.64861L11.354 3.61127ZM7.544 9.49927H6.5V8.46061L10.6467 4.31794L11.7007 5.35461L7.544 9.49927Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.527f56f2005f554fc8b370fd26340cc2.svg";
export { ForwardRef as ReactComponent };